var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "117.56px",
    height: "128.03px",
    viewBox: "0 0 117.56 128.03",
    style: {
      enableBackground: "new 0 0 117.56 128.03"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0C958F;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#3376B7;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F0D784;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#F63137;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#F63137;stroke:#F63137;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#F63137;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st12{fill:#F63137;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#0C958F;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#3376B7;stroke-width:13;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.83,30.17c-20.25,2.03-40.66,2.53-60.99,1.47c-0.03,16.13-0.06,32.26-0.09,48.39 c22.69-0.26,45.38-0.53,68.07-0.79c-0.13-13.7-0.26-27.4-0.4-41.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.99,52.1c0.19,0.97,0.29,1.98,0.29,3.01c0,8.28-6.49,15-14.5,15s-14.5-6.72-14.5-15s6.49-15,14.5-15 c2,0,3.91,0.42,5.64,1.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.98,41.71c-2.73,5.39-5.46,10.77-8.19,16.16c5.29-1.81,11.21-3.97,16.5-5.77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.43,41.29c4.34,1.9,8.28,6.38,8.65,11.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.b0efac0397ccf72dea9b01186f751b4b.svg";
export { ForwardRef as ReactComponent };